import { toast } from "react-toastify"
import { _FixedAssetReplacement, _single } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../theme/Component/BasicPage"
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable"
import { useEffect, useState } from "react"
import usePaginator from "../../../theme/Component/usePaginator"
import { InputDate } from "../../../theme/Input/InputDate"
import { EditorFixedAssetItemByOperationState } from "../../../editor/AssetItemsByOperationState/EditorFixedAssetItemByOperationState"
import { Product } from "../../../Inventories-Warehouses/Product/Product"
import { SelectProductEditor } from "../../ManufacturingStandars/Components/SelectProductEditor"
import { SelectArticleClassCodeTree } from "../../../contabilidad/catalogo-bienes/SelectArticleClassCodeTree"
import { BasicButton } from "../../../theme/Component/BasicButton"
import { PrintJson } from "../../../theme/Component/PrintJson"
import { DropDown } from "../../../theme/Component/DropDown"
import { Modal } from "../../../theme/Component/Modal"
import { ExportXLSL } from "../../../theme/Component/ExportXLSX"
import useModal, { MODAL_md } from "../../../theme/Component/hooks/useModal"

interface DataForm {
    From: any;
    Upto: any;
    IDFixedAsset: number;
    IDItem: number;
    IDProduct: number;
    IDLnArticleClassCode: number;
    IDWorkMaintenanceOrder: number;
    IDTechnnicianExpertices: number;
    RegexStr: string;
}

export const ReportMaintenanceCostDetailed = () => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_FixedAssetReplacement)
    const paginador = usePaginator();

    const [formData, setFormData] = useState<Partial<DataForm>>({});
    const [listaExport, setListaExport] = useState<any[]>([]);

    const modalExportList = useModal(`Reporte de Informe de Costos Detallados`, MODAL_md);

    const head = [
        { title: 'ID Repuesto', property: 'IDFixedAssetReplacement', visible: true },
        { title: 'Orden de Mantenimiento', property: 'IDWorkMaintenanceOrder', visible: true, mask: MASK_NUMBER },
        { title: 'IDProducto', property: 'IDProduct', visible: true },
        { title: 'Código Producto', property: 'ProductCode', visible: true },
        { title: 'Nombre Producto', property: 'Description', visible: true },
        { title: 'Código Tipo Recurso', property: 'ArticleClassCode', visible: true },
        { title: 'Nombre Recurso', property: 'ArticleClassCodeName', visible: true },
        { title: 'ID Activo Fijo', property: 'IDFixedAsset', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre de Activo Fijo', property: 'FixedAssetName', visible: true },
        { title: 'Placa de Activo Fijo', property: 'TicketCode', visible: true },
        { title: 'Objeto de Mantenimiento', property: 'RequestMaintenanceObservations', visible: true },
        { title: 'Especialidad Mantenimiento', property: 'RenderTechnicianExperticies', visible: true },
        { title: 'Valor Hora Técnico', property: 'ValuePerHour', visible: true, mask: MASK_MONEY },
        { title: 'Cantidad Repuesto', property: 'Quantity', visible: true, mask: MASK_NUMBER },
        { title: 'Valor Repuesto', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Documento', property: 'EntityDoc', visible: true },
        { title: 'Observaciones Repuesto', property: 'Observations', visible: true },
    ]



    useEffect(() => {
        if (validateForm() > 0) {

        } else {
            getLista();
        }
    }, [paginador.page])

    const getLista = () => {
        instance.getFixedAssetReplacementCatalogByPeriod(formData.From, formData.Upto, formData.IDFixedAsset, formData.IDItem, formData.IDProduct, formData.IDLnArticleClassCode, formData.IDWorkMaintenanceOrder, formData.IDTechnnicianExpertices, formData.RegexStr, paginador.page, 15).then(
            (resp) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties
                    data.EntityDoc = data.Mnemonic ? `${data.Mnemonic} - ${data.Consecutive}` : "N/P"
                });
                setLista(resp.List);
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const getListaExport = () => {
        instance.getFixedAssetReplacementCatalogByPeriod(formData.From, formData.Upto, formData.IDFixedAsset, formData.IDItem, formData.IDProduct, formData.IDLnArticleClassCode, formData.IDWorkMaintenanceOrder, formData.IDTechnnicianExpertices, formData.RegexStr, 1, 15 * paginador.pages).then(
            (resp) => {
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties
                    data.EntityDoc = data.Mnemonic ? `${data.Mnemonic} - ${data.Consecutive}` : "N/P"
                });
                setListaExport(resp.List);
                modalExportList.open();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            getLista()
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "From", "Upto"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (formData[field] === null || formData[field] === undefined || formData[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const actionsDropDown = [
        { id: 1, name: 'Generar Reporte', permiso: null, activo: true },
    ];

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={actions} />
                </div>
            </div>
        )
    }

    const actions = (e: any) => {
        if (e.id === 1) {
            getListaExport();
        }
    }

    return (
        <BasicPage titulo="Informe de Costos Detallados por Mantenimiento" >
            <div className="row">
                <div className="col-md-3">
                    <label className={`${missingFields.includes('From') ? 'has-error' : ''}`} >Fecha Inicio</label>
                    <InputDate name="" value={formData.From} label=" " setDate={(e) => {
                        console.log(e)
                        setFormData({ ...formData, From: e })
                    }} />
                </div>
                <div className="col-md-3">
                    <label className={`${missingFields.includes('Upto') ? 'has-error' : ''}`} >Fecha Fin</label>
                    <InputDate name="" value={formData.Upto} label=" " setDate={(e) => { setFormData({ ...formData, Upto: e }) }} />
                </div>
                <div className="col-md-6">
                    <EditorFixedAssetItemByOperationState idSelector={formData.IDItem} label="Item de Activo" onChange={(e) => { setFormData({ ...formData, IDItem: e.IDItem }) }} />
                </div>

                <div className="col-md-6">
                    <SelectProductEditor label="Repuesto Utilizado" onChange={(e) => { setFormData({ ...formData, IDProduct: e.IDProduct }) }} />
                </div>

                <div className="col-md-6">
                    <SelectArticleClassCodeTree onChange={(e) => { setFormData({ ...formData, IDLnArticleClassCode: e.IDLn }) }} label="Tipo de Recurso" />
                </div>

                <div className="col-md-6">
                    <label>Búsqueda por Objeto de Mantenimiento</label>
                    <input type="text" className="form-control" value={formData.RegexStr} onChange={(e) => { setFormData({ ...formData, RegexStr: e.target.value }) }} />
                </div>

                <div className="col-md-3">
                    <BasicButton eventClick={() => { validateData() }} icon="ri-search-line" children={`Buscar`} useMargin />
                </div>

                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} records={paginador} />
                    <Modal modal={modalExportList.modal} updateModal={modalExportList.setModal}>
                        {listaExport.length > 0 &&
                            <ExportXLSL customName={"Costos_Detallados"} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaExport} onExport={(name: string) => {
                                _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                            }} />
                        }
                    </Modal>
                </div>
            </div>
        </BasicPage >
    )
}